import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './guides.module.scss';

const Guide = ({imgSrc, imgAlt, heading, href, text}) => (
  <a href={href} target="_blank">
    <div className={classNames('card', styles.Guide)}>
      <div className="card-image">
        <figure className="image">
          <img alt={imgAlt} className={styles.Guide__img} src={imgSrc} />
        </figure>
      </div>
      <div className="card-content">
        <p className={classNames('has-text-black', styles.Guide__heading)}>
          <strong>{heading}</strong>
        </p>
        <p>{text}</p>
      </div>
    </div>
  </a>
);

Guide.propTypes = {
  heading: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  imgAlt: PropTypes.string,
  imgSrc: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

Guide.defaultProps = {
  imgAlt: '',
};

export default Guide;



// WEBPACK FOOTER //
// ./src/components/guides/Guide.js